module.exports = __webpack_public_path__ + "static/img/about_bg_01_zh.87379a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg_01_zh.png
// module id = EuQr
// module chunks = 34